import { FC } from 'react';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type IconTagProps = {
  text: string, 
  icon: IconDefinition
};

export const IconTag: FC<IconTagProps> = ({ text, icon }) => {
  return (
    <div className="icon-tag">
      {icon && <FontAwesomeIcon icon={icon} />} {text}
    </div>
  );
};
